export interface WechatHKPlugin {
    echo(options: { value: string }): Promise<{ value: string }>;
    makePaymentRequest(options: { options: MPayWeChatParams }): Promise<any>;
}

/*
merchantId: 'Merchant ID provided by mPay.',

merchantTId: 'Merchant Terminal ID provided by mPay.',

Order number of transaction. The value should be unique for each payment.
orderNum: 'xxx',

Payment amount of transaction.
Maximum in 2 decimal places.
Default minimum amount is set as follows:
HKD - 10.00
RMB - 10.00
USD - 2.00

amt: '0.1',


Payment currency code of transaction allowed for merchant.
"HKD" - Hong Kong Dollar
"RMB" - China Yuan Renminbi
"USD" - US Dollarf

currency: 'HKD',

Value to identify the payment method in mPay. Used in setCardType function.
Payment         Method	Channel	Value
ALIPAY CN    MOBILE	23
ALIPAY HK    MOBILE	36
OCTOPUS        MOBILE	27
TAP&GO        MOBILE	61
WECHANT PAY    MOBILE	42

paymethod: '42',


The language used in mPay and FI side (if allowed).
"en_US" - English
"zh_TW" - Traditional Chinese
"zh_CN" - Simplified Chinese

locale: 'zh_TW',

Store ID of this transaction take place.Used for Face to Face mode only. If not used, just put in "1" as default.
storeId: '1',

dataHash: 'xxxx',

isPrd: true,

domainUrl: 'xxx',

universalLink: 'xxxxx',

Order date of transaction. The value should be in the format of "yyyyMMddHHmmss".

datetime


The salt value generated. Used for security validation.
Please generate random alphanumeric values with length 16. (e.g. whi1i7lifa70yhgs)

salt

The notify URL of merchant which receive payment response from mPay server to merchant server notification.

notifyUrl

*/
export interface MPayWeChatParams {
    merchantId: string,
    merchantTId: string,
    orderNum: string,
    amt: string,
    currency: string,
    locale: string,
    storeId: string,
    // cardNum: string,
    // extraField1: string,
    dataHash: string,
    domainUrl: string,
    isPrd: boolean,   // true: Production , false: Test
    universalLink: string,
    paymethod: string,
    datetime: string,
    salt: string,
    notifyUrl: string,
    returnUrl: string,
    version: string,
    appScheme: string,
    customizedData: string,
    fullUrl: string
};
